import WorkshopClient from '@/api/CampusAdmin/WorkshopReportsClient';

const PageBy = {
  WorkshopByWhenAsc: 'WorkshopByWhenAsc'
}

export default class FeedbackReport {
  constructor() {
    this.workshopClient = null;
    this.schoolId = 0;
    this.loading = false;

    this.token = undefined;

    this.parameters = {
      pageToken: PageBy.WorkshopByWhenAsc
    };

    this.workshops = [];
  }

  get hasNext() {
    return !!this.parameters.pageToken
      && this.parameters.pageToken != PageBy.WorkshopByWhenAsc;
  }

  initialize($http, schoolId) {
    this.workshopClient = new WorkshopClient($http);

    return this;
  }

  reset() {
    this.parameters.pageToken = PageBy.WorkshopByWhenAsc;
    return this.fetch();
  }

  fetch() {
    if(!this.parameters.pageToken || this.parameters.pageToken === PageBy.WorkshopByWhenAsc)
      this.workshops.length = 0;
    return this.#callAsyncAndIgnorePreviousCalls(
      this.#getData.bind(this), 
      this.#handleResponse.bind(this));
  }

  async #callAsyncAndIgnorePreviousCalls(call, onsuccess) {
    if (this.token) {
      this.token.canceled = true;
    }

    const localToken = {
      canceled: false
    };
    this.token = localToken;

    const result = await call()

    if (localToken.canceled) {
      return;
    }

    onsuccess(result);
  }

  #getData() {
    this.loading = true;

    return this.workshopClient.getWorkshops({
      pageToken: this.parameters.pageToken
    });
  }

  #handleResponse(response){
    this.parameters.pageToken = response.nextPageToken;
    this.workshops.push(...response.workshops)
    this.loading = false;
  }
}
